import axios from "axios";

export class apiLogin {
  //========集料管理==========//
  //分页查询 集料列表
  static login(queryParams) {
    const query = queryParams;
    return axios({
      url: "/login",
      method: "POST",
      params: query,
    });
  }
  
  static getLoginStatus(queryParams) {
    const query = queryParams;
    return axios({
      url: "/at/authorization/getLoginStatus",
      method: "GET",
      params: query,
    });
  }

}
